module.exports = __webpack_public_path__ + "img/05-03_Being Knowledgeable.0b5574be.svg";